import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { DashboardApi } from '@yoso/analytics-portal-client';

/**
 * Global authentication context.
 */

export const ReportsContext = createContext(null);

/**
 * Global authentication context provider.
 *
 * @param {object} props Properties passed to the provider.
 */
export function ReportsProvider({ children }) {
  const dashboardApi = new DashboardApi();
  const [ dashboards, setDashboards ] = useState([]);
  const [ servers, setServersValue ] = useState([]);
  const [ variables, setVariablesValue ] = useState([]);
  const [ currentDashboard, setCurrentDashboardValue ] = useState({});

  const provided = useMemo(() => ({
    dashboards,
    currentDashboard,
    setCurrentDashboard: (value) => setCurrentDashboardValue(value),
    servers,
    setServers: (value) => setServersValue(value),
    variables,
    setVariables: (value) => setVariablesValue(value),
  }), [ dashboards, currentDashboard, servers, variables ]);

  useEffect(() => {
    async function fetchDashboards() {
      try {
        const res = await dashboardApi.listTopicDashboards('etuisa');
        const sortedDashboards = res.data._embedded.dashboards.filter(dashboard => dashboard.name.toLowerCase() !== 'vouchers');
        sortedDashboards.unshift(res.data._embedded.dashboards.find(dashboard => dashboard.name.toLowerCase() === 'vouchers'));
        setCurrentDashboardValue(sortedDashboards[0]);
        setDashboards(...dashboards, sortedDashboards);
      }catch(e){
        console.error(e);
      }
    };
    fetchDashboards();
  }, []);

  return (
    <ReportsContext.Provider value={provided}>
      {children}
    </ReportsContext.Provider>
  );
}

/**
 * Convenience hook providing {@see AuthenticationContext} to function components.
 */
export function useReports() {
  return useContext(ReportsContext);
}
